import { Box } from '@mui/material';
import bronzeIcon from '@/assets/icons/precious_metal_bronze.png';
import silverIcon from '@/assets/icons/precious_metal_silver.png';
import goldIcon from '@/assets/icons/precious_metal_gold.png';
import platinumIcon from '@/assets/icons/precious_metal_platinum.png';
import legacyIcon from '@/assets/icons/precious_metal_legacy.png';
import darkBlueIcon from '@/assets/icons/tier_graphic_dark_blue.png';
import rubyStar from '@/assets/icons/tier_graphic_ruby_star.png';
import { ApiRewardsTier } from '@api/interfaces/ApiRewardsTier';

export const tierGraphics = {
  Bronze: bronzeIcon,
  Silver: silverIcon,
  Gold: goldIcon,
  Platinum: platinumIcon,
  Legacy: legacyIcon,
  Elite: darkBlueIcon,
  Diamond: darkBlueIcon,
  Blue: darkBlueIcon,
  Star: rubyStar,
} as const;

export interface TierImageProps {
  hasTierGraphics: boolean,
  size?: {
    width: string,
    height: string,
  },
  tier: Pick<ApiRewardsTier, 'name'>,
}

export const TierImage = ({
  hasTierGraphics,
  size,
  tier,
}: TierImageProps) => {
  const src = (hasTierGraphics && tier.name in tierGraphics)
    ? tierGraphics[tier.name as keyof typeof tierGraphics]
    : undefined;

  return (
    <Box
      alt="Tier image"
      component="img"
      src={src}
      sx={{
        height: size?.height ?? '25px',
        objectFit: 'contain',
        width: size?.width ?? '31px',
      }}
    />
  );
};
